// An actionable contact value (Session AEH, FIX-2 B4): an email becomes a mailto: link and a
// phone a tel: link, so a contact detail on an office detail page or the portal footer is
// tappable. Before this only the public pages linked contact details. Anything not recognisable
// as an email or phone renders as plain text; a blank value renders "-".
import type { ReactNode } from "react";

export function ContactValue({
  value,
  kind,
  className = "",
}: {
  value: string | null | undefined;
  kind?: "email" | "phone";
  className?: string;
}): ReactNode {
  const trimmed = value?.trim();
  if (!trimmed) return <span className={className}>-</span>;

  const detected: "email" | "phone" | null =
    kind ?? (trimmed.includes("@") ? "email" : /\d/.test(trimmed) ? "phone" : null);

  if (detected === "email") {
    return (
      <a href={`mailto:${trimmed}`} className={`min-w-0 [overflow-wrap:anywhere] ${className}`.trim()}>
        {trimmed}
      </a>
    );
  }
  if (detected === "phone") {
    // tel: URIs accept digits and a leading +, nothing else.
    return (
      <a href={`tel:${trimmed.replace(/[^\d+]/g, "")}`} className={className}>
        {trimmed}
      </a>
    );
  }
  return <span className={className}>{trimmed}</span>;
}
